import React from "react";

/**
 * @typedef {object} ViewContextValue
 * @property {string} view Current view ('individual' or 'team')
 * @property {function(string): void} setView Set the current view
 * @property {Array} teams Array of teams
 * @property {string|null} selectedTeamId Currently selected team ID
 * @property {function(string): void} setSelectedTeamId Set the selected team ID
 */

const ViewContext = React.createContext(null);

/**
 * Provider for view context
 * @param {object} props Component props
 * @param {React.ReactNode} props.children Child components
 * @param {ViewContextValue} props.value Context value
 * @returns {React.ReactElement} View context provider
 */
export function ViewProvider({ children, value }) {
  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
}

/**
 * Hook to use view context
 * @returns {ViewContextValue|null} View context value
 */
export function useView() {
  return React.useContext(ViewContext);
}
